// extracted by mini-css-extract-plugin
module.exports = {"num":"table_num__Dr_mo","activeRow":"table_activeRow__38mop","lit":"table_lit__2lVEd","hilit":"table_hilit__3WGmk"};